import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { Button } from '@/components/ui/button';
import { CocktailIcon } from '@/components/Brand';
import { InstallButton } from '@/components/InstallButton';
import { SignOut, ShieldStar, ChartBar } from '@phosphor-icons/react';

export function TopNav() {
  const { user, logout } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  const onDashboard = location.pathname.startsWith('/dashboard');
  const onAdmin = location.pathname.startsWith('/admin');

  return (
    <header
      data-testid="top-nav"
      className="sticky top-0 z-30 backdrop-blur-xl bg-black/60 border-b border-white/5"
      style={{ paddingTop: 'env(safe-area-inset-top)' }}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-3 sm:py-4 flex items-center justify-between gap-2">
        <Link to="/dashboard" className="flex items-center gap-2 min-w-0" data-testid="nav-logo-link">
          <CocktailIcon className="text-[#D4AF37] shrink-0" size={24} />
          <div className="font-display text-base sm:text-lg font-medium tracking-tight truncate">kahrency</div>
        </Link>

        <div className="flex items-center gap-1 sm:gap-2 shrink-0">
          {user?.role === 'admin' && (
            <Button
              variant="ghost"
              size="sm"
              data-testid="nav-dashboard-btn"
              onClick={() => navigate('/dashboard')}
              className={`text-slate-300 hover:bg-white/10 px-2 sm:px-3 ${onDashboard ? 'text-[#D4AF37]' : ''}`}
              aria-label="Dashboard"
            >
              <ChartBar size={18} weight="duotone" className="sm:mr-2" />
              <span className="hidden sm:inline">Dashboard</span>
            </Button>
          )}
          {user?.role === 'admin' && (
            <Button
              variant="ghost"
              size="sm"
              data-testid="nav-admin-btn"
              onClick={() => navigate('/admin')}
              className={`text-slate-300 hover:bg-white/10 px-2 sm:px-3 ${onAdmin ? 'text-[#D4AF37]' : ''}`}
              aria-label="Admin"
            >
              <ShieldStar size={18} weight="duotone" className="sm:mr-2" />
              <span className="hidden sm:inline">Admin</span>
            </Button>
          )}

          <div className="hidden md:flex items-center px-3 py-1.5 rounded-full border border-white/10 bg-white/5">
            <span className="label-eyebrow text-[10px] mr-2">USER</span>
            <span data-testid="nav-username" className="text-sm text-white">{user?.username}</span>
          </div>

          <InstallButton className="hidden sm:inline-flex" />

          <Button
            variant="ghost"
            size="sm"
            data-testid="nav-logout-btn"
            onClick={async () => { await logout(); navigate('/login'); }}
            className="text-slate-400 hover:text-red-400 hover:bg-red-500/10 px-2 sm:px-3"
            aria-label="Sign out"
          >
            <SignOut size={18} weight="duotone" className="sm:mr-2" />
            <span className="hidden sm:inline">Sign out</span>
          </Button>
        </div>
      </div>
    </header>
  );
}
